export default "__VITE_ASSET__dz2LYYyR__"